<script setup  lang="ts">
defineProps<{ mode: 'open' | 'close' }>()

const searchMode = defineModel<boolean>('searchMode', { default: false })

const searchTerm = useRouteQuery<string>('q', '')

const { open } = useReadingView('book-view-stack')

function onSearchInput(value: string) {
  searchMode.value = !!value
}

function onSearchSubmit() {
  const trimmed = searchTerm.value.trim()
  searchMode.value = !!trimmed
  // Search results (BookSearch) render in the toc view; switch to it so they're visible when submitting from the reading view.
  if (trimmed) {
    open('toc')
  }
}

function onSearchReset() {
  searchMode.value = false
  searchTerm.value = ''
}
</script>

<template>
  <ReadingMobileTableOfContentBar :mode="mode" view-key="book-view-stack" open-label="Åpne innhold og søk">
    <form role="search" class="flex-1" @submit.prevent="onSearchSubmit">
      <FormSearchInput
        :id="`book-mobile-search-${mode}`"
        v-model="searchTerm"
        class="w-full"
        shape="square"
        size="medium"
        name="q-mobile"
        color="carbon"
        label="Søk i denne boken"
        placeholder="Søk i denne boken"
        resettable
        @reset="onSearchReset"
        @update:model-value="onSearchInput"
      />
    </form>
  </ReadingMobileTableOfContentBar>
</template>
